import React from "react";
var __jsx = React.createElement;
import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
import sanitizeText from '@anm/helpers/string/sanitizeText';
import { CTAButton, LandingCTAWrapper } from './Wrapper';
import useCTAClick from './hooks';
import isInIframe from '@anm/helpers/is/isInIframe';
export { LandingCTAWrapper };

var LandingCTA = function LandingCTA(_ref) {
  var cta = _ref.cta,
      CTAref = _ref.CTAref,
      projectId = _ref.projectId,
      fontStyles = _ref.fontStyles,
      isCentered = _ref.isCentered,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'pure' : _ref$theme,
      _ref$playerColor = _ref.playerColor,
      playerColor = _ref$playerColor === void 0 ? DEFAULT_WAVE_COLOR : _ref$playerColor;
  var isCTAExists = !!(cta && cta.buttonText && !cta.disabled);
  var onCTAClick = useCTAClick(projectId, cta);
  var isIframe = isInIframe();

  var handleClick = function handleClick(e) {
    onCTAClick();

    if (isIframe && cta !== null && cta !== void 0 && cta.buttonLink) {
      e.preventDefault();
      window.parent.location.href = cta.buttonLink;
    }
  };

  if (!isCTAExists) return null;
  return __jsx(LandingCTAWrapper, {
    ref: CTAref,
    isCentered: isCentered
  }, __jsx(CTAButton, {
    fontStyles: fontStyles,
    size: "large",
    buttonTheme: theme,
    variant: "no-wrapper-centered",
    bgColor: playerColor,
    onClick: handleClick,
    href: (cta === null || cta === void 0 ? void 0 : cta.buttonLink) || '#'
  }, sanitizeText(cta === null || cta === void 0 ? void 0 : cta.buttonText)));
};

export default LandingCTA;